/**
 * Copyright 2013-2017 Zegeba AS (814 777 812 MVA), Ålesund, Norway
 *                     www.zegeba.com - contact@zegeba.com
 *
 * All rights reserved. You may not use or distribute the content of this file
 * in part or as a whole without explicit written consent from Zegeba AS.
 *
 * This software/the content of this file is distributed AS IS, WITHOUT WARRANTIES OF ANY KIND.
 * Zegeba AS or the authors of the software accepts NO LEGAL LIABILITY OR RESPONSIBILITY for any
 * loss due to the use of the software/content of this file.
 *
 */
<script>
import Notification from "./components/elements/Notification";

export default {
	name: "App",
	components: { Notification },
	data() {
		return {
			authenticated: false,
		};
	},
	methods: {
		setAuthenticated(status) {
			this.authenticated = status;
		},
	}
};

</script>
<template>
	<v-app>
		<div id="app" data-app>
			<top-navbar v-if="!this.$route.meta.requiresUnauth"/>
			<v-main id="mainContent">
				<transition
					name="fade"
					mode="out-in"
				>
					<keep-alive>
						<router-view
							@authenticated="setAuthenticated"
							:key="$route.fullPath"
						/>
					</keep-alive>
				</transition>
				<notification/>
			</v-main>
		</div>
	</v-app>
</template>

<style>
#app {
	text-align: left;
	margin-top: 50px;
	margin-left: 30px;
	margin-right: 30px;
	margin-bottom: 50px;
	overflow: hidden;
	margin: 0;
	padding: 0;
	-webkit-text-size-adjust: none;	/* prevent webkit from resizing text to fit */
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	cursor: default;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue